import {Component, OnInit} from '@angular/core';
import {DashboardService} from '../../services/events/dashboard.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private dashboard: DashboardService,
    private router: Router) {
}

ngOnInit() {
  this.dashboard.setMenuItem('inicio');
  //console.log("home: oninit()");
}

goto(id: string) {
  //console.log("home: goto()");
  this.router.navigate(['dashboard', id]);
}

}
